// @ts-nocheck
/**
 * 市場連鎖システム - 文言テンプレート
 *
 * chain_info/chain_news_templates.md に基づく実装
 * 約400個の文言テンプレート
 */

// ========================================
// 1. 基本連鎖の文言テンプレート
// ========================================

// ----------------------------------------
// 1.1 正連鎖（Positive Chain）
// ----------------------------------------

/**
 * 正連鎖の汎用テンプレート
 * ${source} = 元のテーマ, ${target} = 連鎖先テーマ
 */
export const POSITIVE_CHAIN_TEMPLATES = [
  // 連動系
  '${source}の影響で${target}も連動',
  '${source}人気の波及で${target}にも注目',
  '${source}の好調を受け${target}も上昇気配',
  '${source}との相乗効果で${target}も活況',
  // 需要系
  '${source}需要の高まりが${target}にも波及',
  '${source}ブームで${target}の需要も増加',
  '${source}人気に引っ張られ${target}も好調',
  // 市場系
  '${source}市場の活況が${target}に飛び火',
  '${source}への資金流入が${target}にも',
  '関連市場として${target}にも買いが入る',
  // 期待系
  '${source}の動きを見て${target}にも期待感',
  '${source}に続き${target}も注目される',
  '次は${target}との見方が広がる',
];

/**
 * 正連鎖のテーマ固有テンプレート
 * キー: '元テーマ→連鎖先テーマ'
 */
export const POSITIVE_CHAIN_THEMED = {
  // 炎属性系
  'ドラゴン→フェニックス': [
    '炎龍の咆哮に不死鳥も呼応',
    'ドラゴンの炎がフェニックスを目覚めさせる',
    '龍の血脈が不死の炎を呼ぶ',
  ],
  'ドラゴン→岩狸': [
    '龍の素材需要で岩狸の鍛冶も活況',
    'ドラゴンの甲殻を求め岩狸に依頼殺到',
    '炎竜の巣周辺で岩狸の採掘が活発化',
  ],
  '岩狸→ゴーレム': [
    '岩狸の新素材がゴーレム産業に革命',
    'マグマフォージの技術がエクラシアに輸出',
    '熔岩鋼の供給増でゴーレム生産が加速',
  ],
  '岩狸→ドラゴン': [
    '岩狸の鍛冶技術で竜騎士の装備が強化',
    'マグマフォージの炎がドラゴンを引き寄せる',
    '火山の活発化でドラゴンの目撃情報増加',
  ],

  // 水属性系
  'ヴェルゼファール→リヴァイアサン': [
    '深海の使者の動きに海獣も呼応',
    'ヴェルゼファールの領域拡大でリヴァイアサンも活性化',
    '深淵の支配者に海の古獣も従う',
  ],
  'ヴェルゼファール→ブリザードキャット': [
    '海の冷気が氷猫の力を高める',
    '深海の潮流が凍てつく北へ',
    'ヴェルゼファールの波が氷の大地に届く',
  ],
  'ブリザードキャット→ヴェルゼファール': [
    '氷の魔力が海の深淵を冷やす',
    '凍結の波動が深海に響く',
    '氷猫の吹雪が海流を変える',
  ],

  // 光属性系
  '鳥民→ヴォランティス': [
    '鳥民の祈りが巨鳥を呼ぶ',
    '天翔秘島の祭典でヴォランティスの羽音',
    '鳥民の儀式に巨鳥が応える',
  ],
  '鳥民→フェニックス': [
    '光の民の祈りが不死鳥を照らす',
    '天翔秘島に聖獣の加護',
    '鳥民と不死鳥の古い盟約が蘇る',
  ],
  'フルーツ・マリオネット→虹羽密林': [
    '果実の精霊が密林の恵みを呼ぶ',
    '人形劇の種が密林に芽吹く',
    'フルーツの香りが虹羽の森に届く',
  ],

  // 闇属性系
  '魔女→黒呪': [
    '魔女の詠唱が呪いの力を増幅',
    'エリザヴェットの影響で黒呪が活性化',
    '魔女の塔から呪いの波動が広がる',
  ],
  '魔女→シャドウ': [
    '魔女の闇が影を濃くする',
    'エリザヴェットの命令で影が蠢く',
    '黒呪の大陸に影が集う',
  ],
  '魔女→ゴシック': [
    '魔女の美学がゴシックに影響',
    'エリザヴェットの趣味で人形が踊る',
    '魔女の館にゴシックの調べ',
  ],
  '黒呪→シャドウ': [
    '呪いの力が影を呼び寄せる',
    '呪術の闇にシャドウが潜む',
    '呪詛の波動が影を濃くする',
  ],
  'ゴシック→鎖縛': [
    'ゴシックの拘束美学が鎖を彩る',
    '人形の鎖が新たな意匠を纏う',
    'ゴシック姫の命令で鎖が踊る',
  ],
  'リリカ→ゴシック': [
    '幼魔王女の趣味でゴシック人形が増産',
    'リリカのお気に入りがゴシック市場を動かす',
    '魔界の姫君がゴシックを愛でる',
  ],

  // 原始属性系
  '粘液獣→虹羽密林': [
    '粘液の養分が密林を潤す',
    '粘液獣の繁殖が生態系を活性化',
    'スライムの分解が森に栄養を',
  ],
  '虹羽密林→フルーツ・マリオネット': [
    '密林の実りが果実人形に力を',
    '虹羽の花粉がフルーツを育てる',
    '密林の恵みが人形劇に彩りを',
  ],
  '虹羽密林→鳥民': [
    '密林の変化が天翔秘島に届く',
    '渡り鳥が密林と島を繋ぐ',
    '虹羽の種が鳥民の祭壇に',
  ],

  // 未来属性系
  'ゴーレム→未来鴉': [
    'ゴーレム技術が機械鴉を進化させる',
    'エクラシアの発明がミランの鴉に宿る',
    '魔導機の技術が未来鴉に応用',
  ],
  'ゴーレム→鎖縛': [
    '機械仕掛けの拘束具が開発される',
    'ゴーレム技術で鎖の精度が向上',
    '魔導の鎖が新たな可能性を',
  ],
  '未来鴉→ゴーレム': [
    'ミランの予言がゴーレム開発を導く',
    '未来鴉の情報で新型ゴーレム設計',
    '時を読む鴉が機械の進化を示す',
  ],

  // 複合系
  'ヴォランティス→鳥民': [
    '巨鳥の飛来に鳥民が歓喜',
    'ヴォランティスの祝福が島に降り注ぐ',
    '空の王の庇護で鳥民が栄える',
  ],
  'ヴォランティス→フェニックス': [
    '巨鳥の風が不死鳥の炎を煽る',
    '空の覇者たちが呼応する',
    'スカイレジェンドの共鳴',
  ],
  'フェニックス→ドラゴン': [
    '不死鳥の再生炎がドラゴンを目覚めさせる',
    '炎の翼が龍の巣を照らす',
    'フェニックスとドラゴン、炎の同胞',
  ],
  'フェニックス→鳥民': [
    '不死鳥の加護が鳥民に恵みをもたらす',
    '聖なる炎が天翔秘島を温める',
    'フェニックスの羽が鳥民の祭壇に',
  ],
};

// ----------------------------------------
// 1.2 対抗連鎖（Counter Chain）
// ----------------------------------------

/**
 * 対抗連鎖の汎用テンプレート
 */
export const COUNTER_CHAIN_TEMPLATES = [
  // 対策系
  '${source}対策として${target}の需要が増加',
  '${source}への備えで${target}が注目される',
  '${source}メタとして${target}に買いが入る',
  // 警戒系
  '${source}の台頭に${target}が警戒態勢',
  '${source}の動きを受け${target}が動き出す',
  '${source}への対抗策として${target}が浮上',
  // 需要系
  '${source}を抑えるため${target}の需要増',
  '${source}対策カードとして${target}に注目',
  '環境の${source}に対して${target}で対抗',
];

/**
 * 対抗連鎖のテーマ固有テンプレート
 */
export const COUNTER_CHAIN_THEMED = {
  // 属性対立
  '岩狸→ブリザードキャット': [
    '熔岩の熱に対抗し氷の猫が立ち上がる',
    '炎山の活発化で氷猫の需要が増加',
    'マグマフォージの炎を冷やす者を求む',
  ],
  'ブリザードキャット→岩狸': [
    '氷結の脅威に熔岩の力で対抗',
    '凍てつく大地を溶かす鍛冶師を求む',
    '氷の猫を退けるは炎の狸',
  ],
  'ドラゴン→ブリザードキャット': [
    '龍の炎を鎮める氷の力が求められる',
    'ドラゴン対策に氷猫が有効と判明',
    '炎龍を凍らせる戦術が流行',
  ],

  // 光闇対立
  '鳥民→シャドウ': [
    '光の民に対し影が備える',
    '鳥民の浄化に影が身を潜める',
    '光と影の永遠の対立が再び',
  ],
  '鳥民→魔女': [
    '光の民の動きに魔女が警戒',
    '鳥民の祈りが魔女の闇を脅かす',
    '浄化の光に呪いで対抗',
  ],
  'シャドウ→鳥民': [
    '影の脅威に光の民が立ち上がる',
    'シャドウ対策に鳥民の祈りが有効',
    '闇を払う光が求められる',
  ],
  '魔女→鳥民': [
    '魔女の呪いに光の祈りで対抗',
    '黒呪の大陸に鳥民の使者が',
    '闇を祓う翼が求められる',
  ],

  // 自然vs機械
  '虹羽密林→ゴーレム': [
    '自然の脅威に機械で対抗',
    '密林の侵食を止めるゴーレム開発',
    '有機物を排除する魔導機が求められる',
  ],
  'ゴーレム→粘液獣': [
    '機械の天敵、粘液による腐食対策',
    'ゴーレムを溶かす粘液獣が注目',
    '有機物で機械を止める戦術',
  ],

  // 不死vs呪い
  '黒呪→フェニックス': [
    '呪いを打ち破る不死の炎が求められる',
    '呪殺を無効化するフェニックスに注目',
    '再生の力で呪いに対抗',
  ],
  'フェニックス→黒呪': [
    '不死を殺す呪いの研究が活発化',
    'フェニックス対策に呪術が有効と判明',
    '再生を封じる呪縛が求められる',
  ],

  // 宿敵系
  'ドラゴン→呪術狩り': [
    '龍の脅威に狩人たちが集う',
    'ドラゴン討伐の依頼が殺到',
    '龍を狩る者たちへの需要増',
  ],
  'ドラゴン→鉄槍騎士団': [
    '龍討伐の遠征計画が始動',
    'ドラゴンの脅威に騎士団が動く',
    '竜殺しの英雄を求める声',
  ],
  '魔女→呪術狩り': [
    '魔女の暗躍に呪術狩りが呼応',
    'エリザヴェットの動きに狩人が備える',
    '魔女狩りの季節が到来',
  ],
  'リリカ→鉄槍騎士団': [
    '幼魔王女の動きに騎士団が警戒',
    'リリカ討伐の遠征計画が浮上',
    '魔界の姫に対抗する騎士道',
  ],
  '未来鴉→呪術狩り': [
    'ミランの予言が狩人を導く',
    '未来鴉の情報で呪術の拠点が判明',
    '時を読む鴉が狩りを効率化',
  ],
  '未来鴉→魔女': [
    'ミランの予言が魔女にも届く',
    '未来鴉の情報は敵にも漏れる',
    '時の情報は光にも闇にも',
  ],
};

// ----------------------------------------
// 1.3 負連鎖（Negative Chain）
// ----------------------------------------

/**
 * 負連鎖の汎用テンプレート
 */
export const NEGATIVE_CHAIN_TEMPLATES = [
  // 資金流出系
  '${source}への資金集中で${target}から資金流出',
  '${source}人気の裏で${target}は売り優勢',
  '${source}に資金が移り${target}は軟調',
  // 競合系
  '${source}の台頭で${target}の立場が危うく',
  '${source}優勢で${target}の需要が減少',
  '${source}に押され${target}は下落',
  // 衰退系
  '${source}の時代、${target}は過去のものに',
  '${source}ブームの陰で${target}は忘れられ',
  '今は${source}、${target}離れが進む',
];

/**
 * 負連鎖のテーマ固有テンプレート
 */
export const NEGATIVE_CHAIN_THEMED = {
  // 領域対立
  'ヴォランティス→ヴェルゼファール': [
    '空の覇権に海の勢力が警戒、投資控え',
    '巨鳥の時代に深海は沈黙',
    '空を見上げる者が増え、海は忘れられ',
  ],
  'ヴォランティス→リヴァイアサン': [
    '空の王の前に海獣は影を潜める',
    '巨鳥の風に海の獣は身を隠す',
    'スカイレジェンドの時代、海獣は低迷',
  ],
  'ヴェルゼファール→鳥民': [
    '深海の脅威に空の民は萎縮',
    '海の覇者の前に翼は無力',
    '深淵の影が空を覆う',
  ],
  'ヴェルゼファール→ヴォランティス': [
    '海の王の台頭で空の覇者は警戒',
    '深淵の力に巨鳥も翼を休める',
    '海が支配する時、空は静まる',
  ],

  // 光闇対立
  '魔女→フルーツ・マリオネット': [
    '闇の時代に光の人形は売れず',
    '魔女の影響で明るい人形は不人気に',
    '呪いの流行で可愛いものは敬遠',
  ],
  '魔女→鳥民': [
    '魔女の呪いが光の民を萎縮させる',
    '黒呪の大陸から闇が広がり光は翳る',
    '魔女の時代、鳥民は祈るのみ',
  ],
  '鳥民→シャドウ': [
    '光の浄化で影は居場所を失う',
    '鳥民の祈りが影を追い払う',
    '光の時代、影は薄れゆく',
  ],

  // 生態系
  'ブリザードキャット→粘液獣': [
    '氷の猫に凍らされ粘液獣は縮小',
    '凍結の波動で粘液の活動が鈍る',
    '氷の時代、粘液は凍りつく',
  ],
  'フェニックス→虹羽密林': [
    '不死鳥の炎が密林の一部を焼く',
    'フェニックスの再生炎が森を脅かす',
    '炎の翼の下、緑は枯れる',
  ],

  // 技術vs魔術
  'ゴーレム→魔女': [
    '機械の時代に古い魔術は衰退',
    'ゴーレムの効率に魔女の呪いは霞む',
    '魔導技術の発展で伝統魔術は下火に',
  ],
  'ゴーレム→黒呪': [
    '機械は呪いを恐れず、呪術の価値が下落',
    'ゴーレムに呪いは効かぬと判明',
    '魔導機の前に呪術師は無力',
  ],

  // 地上vs空中
  '岩狸→鳥民': [
    '地上の繁栄に空の民は置いていかれ',
    '火山の富に翼は届かず',
    '地の時代、空は静か',
  ],
  'リヴァイアサン→鳥民': [
    '海獣の脅威に翼では対抗できず',
    '深海の王の前に空の民は無力',
    '海の時代、空は見向きもされず',
  ],

  // その他
  'ドラゴン→ヴェルゼファール': [
    '空を飛ぶ龍の時代、海は沈黙',
    'ドラゴンへの注目で深海は忘れられ',
    '炎龍の咆哮に海の王は身を潜める',
  ],
  '黒呪→呪術狩り': [
    '呪いが蔓延し狩人の仕事は過酷に',
    '呪術の拡大で狩人は苦戦',
    '呪いに呑まれる狩人たち',
  ],
  'ゴシック→フルーツ・マリオネット': [
    '闇の人形に光の人形は押され',
    'ゴシック流行でフルーツは下火に',
    '闘の美学に光は霞む',
  ],
};

// ========================================
// 2. 特殊連鎖の文言テンプレート
// ========================================

// ----------------------------------------
// 2.1 宿敵連鎖（Rivalry Chain）
// ----------------------------------------

export const RIVALRY_CHAIN_TEMPLATES = {
  '魔女↔呪術狩り': [
    '魔女と呪術狩りの衝突が激化、両陣営に緊張',
    '黒呪の大陸で呪術狩りとの戦闘発生',
    '魔女エリザヴェットへの討伐令、呪術狩りが動く',
    '魔女狩りの季節、両者の価値が高騰',
    '宿敵同士の戦い、双方に需要',
    '闇と正義の永遠の戦いが再燃',
    '魔女の暗躍に呪術狩りが呼応',
    '呪術狩りの進軍、魔女も迎撃態勢',
  ],

  'リリカ↔鉄槍騎士団': [
    '幼魔王女討伐の遠征計画が浮上',
    '鉄槍騎士団が魔界への侵攻を宣言',
    'リリカの眷属と騎士団の小競り合い発生',
    '魔王と騎士、宿命の対決に注目',
    '幼き魔王と鉄の槍、再び激突',
    'リリカのご機嫌斜め、騎士団に警戒令',
    '魔界の姫と人間の騎士、永遠の対立',
    '討伐か、それとも...両者に投資家の視線',
  ],

  'ドラゴン↔鉄槍騎士団': [
    '龍討伐の遠征隊が編成される',
    '炎竜母フレイマの目撃情報、騎士団が警戒',
    'ドラゴンの巣への討伐作戦開始',
    '龍と騎士、伝説の戦いが再び',
    '龍殺しの英雄を求む、騎士団が募集',
    'ドラゴンの咆哮に騎士団が応戦',
    '竜の鱗か騎士の誉れか、両者に注目',
    '火を吐く龍と鉄の槍の激突',
  ],

  '黒呪↔フェニックス': [
    '不死鳥への呪殺研究が活発化',
    '聖獣フェニックスに呪いの影が迫る',
    '不死を殺す呪術の開発競争',
    '再生vs呪い、究極の対決',
    '不死の炎と死の呪い、永遠の攻防',
    'フェニックスの不死性を破る呪術とは',
    '呪いと再生、どちらが勝つか',
    '呪殺の技か不死の炎か、研究者が注目',
  ],

  'ヴェルゼファール↔ヴォランティス': [
    '海と空の覇権争いが再燃',
    '深海の王と巨鳥の領域紛争',
    'アクアレギナ上空でヴォランティスと深海勢力が衝突',
    '海の覇者と空の王、宿命の対決',
    '深淵と蒼天、二つの王国が激突',
    '波と風、どちらが世界を支配するか',
    '海上の嵐、両雄の戦いの余波',
    '深海から巨鳥への挑戦状',
  ],
};

// ----------------------------------------
// 2.2 三つ巴連鎖（Triangle Chain）
// ----------------------------------------

export const TRIANGLE_CHAIN_TEMPLATES = {
  'ドラゴン→呪術狩り→魔女': {
    trigger: [
      'ドラゴンの暴走が連鎖的な混乱を呼ぶ',
      '炎龍の目覚めが世界を揺るがす',
      '龍の咆哮が運命の歯車を回す',
    ],
    step1: [
      '龍退治の依頼が呪術狩りに殺到',
      'ドラゴン対策で呪術狩りが動員される',
      '龍の脅威に対抗すべく狩人が集結',
    ],
    step2: [
      '龍討伐後、呪術狩りは魔女討伐へ転進',
      '勢いに乗った呪術狩りが黒呪の大陸へ',
      '龍を倒した者たちが次の標的を求める',
    ],
  },

  '粘液獣→ブリザードキャット→岩狸': {
    trigger: [
      '粘液獣の異常繁殖が各地に影響',
      'スライムの大発生が生態系を乱す',
      '粘液の海が大陸を覆い始める',
    ],
    step1: [
      '粘液を凍らせるため氷猫が動員される',
      'ブリザードマスターが粘液駆除を指揮',
      '凍結作戦で粘液の進行を止める',
    ],
    step2: [
      '凍った粘液を焼き払うため岩狸が出動',
      '熔岩の力で凍結粘液を処理',
      '氷と炎の連携で粘液を殲滅',
    ],
  },

  '鳥民→シャドウ→魔女': {
    trigger: [
      '鳥民の浄化作戦が光と闇のバランスを崩す',
      '天翔秘島の光が世界に広がる',
      '光の民の祈りが闇を脅かす',
    ],
    step1: [
      '光を逃れシャドウが暗躍を開始',
      '浄化から逃れた影が蠢き始める',
      '追い詰められた影が反撃に出る',
    ],
    step2: [
      '影の動きに呼応し魔女が目覚める',
      'シャドウの導きで魔女が力を取り戻す',
      '闇の勢力が結集、魔女を中心に',
    ],
  },

  'ゴーレム→虹羽密林→粘液獣': {
    trigger: [
      '魔導技術の発展が自然環境に影響',
      'エクラシアの工場が拡大を続ける',
      'ゴーレム生産の急増で資源需要が高騰',
    ],
    step1: [
      '開発の波が密林の生態系を乱す',
      '魔導炉の排出物が森に影響',
      '機械の侵食に密林が反応',
    ],
    step2: [
      '乱れた生態系で粘液獣が異常繁殖',
      '密林の変化がスライムを活性化',
      '自然のバランス崩壊で粘液が増殖',
    ],
  },

  '未来鴉→呪術狩り→黒呪': {
    trigger: [
      'ミランの予言が世界を動かす',
      '未来鴉が重大な未来を告げる',
      '紫鴉の囁きが運命を変える',
    ],
    step1: [
      '予言に従い呪術狩りが出陣',
      'ミランの情報で呪術の拠点が判明',
      '未来鴉の導きで狩人が動く',
    ],
    step2: [
      '標的にされた黒呪が防衛を固める',
      '呪術狩りの接近に呪術師が備える',
      '予言された戦いの時が迫る',
    ],
  },
};

// ----------------------------------------
// 2.3 覇権連鎖（Dominion Chain）
// ----------------------------------------

export const DOMINION_CHAIN_TEMPLATES = {
  // 空の覇権
  'ヴォランティス（空）': {
    ruler: [
      '巨鳥ヴォランティスの羽ばたきが空を支配',
      '空の覇者の帰還に世界が注目',
      'スカイレジェンドの時代が到来',
    ],
    vassals: {
      '鳥民': [
        '巨鳥の加護で鳥民が栄える',
        'ヴォランティスの翼の下、鳥民は繁栄',
        '空の王に従い鳥民も力を得る',
      ],
      'フェニックス': [
        '巨鳥の風が不死鳥の炎を煽る',
        '空の覇者たちが共鳴する',
        'ヴォランティスの飛翔にフェニックスも応える',
      ],
    },
    rivals: {
      'ヴェルゼファール': [
        '空の覇権に深海の王は沈黙を強いられる',
        '巨鳥の影に海の支配者は身を潜める',
        '空が支配する時、海は静まる',
      ],
      'リヴァイアサン': [
        '空の時代に海獣は深淵へ',
        '巨鳥の前に海の古獣は無力',
        '空を見上げる者ばかり、海は忘れられ',
      ],
    },
  },

  // 海の覇権
  'ヴェルゼファール（海）': {
    ruler: [
      '深海の使者が海を支配する',
      '海の覇者の目覚めに沿岸が震える',
      '深淵の王の時代が始まる',
    ],
    vassals: {
      'リヴァイアサン': [
        '深海の使者に古き海獣も従う',
        'ヴェルゼファールの命でリヴァイアサンが動く',
        '海の王の下、海獣たちが集う',
      ],
      'ブリザードキャット': [
        '海の冷気が氷猫の力を高める',
        '深海の潮流が凍てつく力を運ぶ',
        '海の覇者の恩恵が氷の大地にも',
      ],
    },
    rivals: {
      'ヴォランティス': [
        '海の覇権に空の王は翼を休める',
        '深淵の力の前に巨鳥も警戒',
        '海が荒れる時、空は飛べず',
      ],
      '鳥民': [
        '海の脅威に空の民は萎縮',
        '深海の影が島々を覆う',
        '海の時代、翼は無力',
      ],
    },
  },

  // 闇の覇権
  '魔女（闇）': {
    ruler: [
      '魔女エリザヴェットが闇の勢力を統べる',
      '黒呪の大陸に闇が深まる',
      '魔女の支配が影と呪いを呼び寄せる',
    ],
    vassals: {
      '黒呪': [
        '魔女の命で呪術が活性化',
        'エリザヴェットの力が呪いを増幅',
        '魔女の塔から呪いの波動が広がる',
      ],
      'シャドウ': [
        '魔女の闇が影を濃くする',
        'エリザヴェットの命令で影が蠢く',
        '魔女の支配下、影は自由に動く',
      ],
      'ゴシック': [
        '魔女の美学がゴシックを彩る',
        'エリザヴェットの趣味で人形が踊る',
        '闇の女王の下、ゴシックは栄える',
      ],
      'リリカ': [
        '魔女の影響で幼魔王女も活発に',
        '闇の連帯でリリカも力を得る',
        '魔女と魔王女、闇の同盟',
      ],
    },
    rivals: {
      '鳥民': [
        '闇の支配に光の民は祈るのみ',
        '魔女の時代、鳥民は翼を畳む',
        '黒呪の影が光を覆い隠す',
      ],
      'フェニックス': [
        '闇の濃さに不死の炎も翳る',
        '魔女の呪いが再生の炎を脅かす',
        '闇の時代、光は弱まる',
      ],
      '呪術狩り': [
        '魔女の台頭に呪術狩りは苦戦',
        '闇が濃すぎて狩人も手が出せず',
        '魔女の力の前に狩人は後退',
      ],
    },
  },

  // 光の覇権
  '鳥民（光）': {
    ruler: [
      '天翔秘島の光が世界を照らす',
      '鳥民の祭典が光の力を高める',
      '光の民の祈りが闇を追い払う',
    ],
    vassals: {
      'フルーツ・マリオネット': [
        '光の恵みで果実人形が活き活きと',
        '鳥民の祝福がフルーツを輝かせる',
        '光の時代、人形劇は大盛況',
      ],
      'フェニックス': [
        '光の祈りが不死鳥を呼ぶ',
        '鳥民の祭壇に聖獣が降臨',
        '光と炎、聖なる力が共鳴',
      ],
    },
    rivals: {
      '魔女': [
        '光の浄化で魔女は力を失う',
        '鳥民の祈りが呪いを弱める',
        '光の時代、魔女は影に潜む',
      ],
      'シャドウ': [
        '光の前に影は消え去る',
        '浄化の力でシャドウは居場所を失う',
        '光が満ちる時、影は薄れる',
      ],
      '黒呪': [
        '光の祈りが呪いを解く',
        '鳥民の力で呪術は無効化',
        '光の時代、呪いは力を失う',
      ],
    },
  },
};

// ----------------------------------------
// 2.4 技術連鎖（Technology Chain）
// ----------------------------------------

export const TECHNOLOGY_CHAIN_TEMPLATES = {
  '岩狸→ゴーレム': [
    '岩狸の新素材がゴーレム産業に革命',
    'マグマフォージの技術がエクラシアに輸出',
    '熔岩鋼の供給増でゴーレム生産が加速',
    '岩狸の鍛冶技術が魔導機を進化させる',
    '火山の恵みが機械の心臓に',
    'マグマフォージ製の部品が高性能ゴーレムを生む',
  ],

  'ゴーレム→未来鴉': [
    'ゴーレム技術が機械鴉を進化させる',
    'エクラシアの発明がミランの鴉に応用',
    '魔導機の技術革新が未来鴉に波及',
    '新型ゴーレムの技術が鴉の翼に',
    '魔導炉の小型化で機械鴉が高性能に',
    '時を読む鴉に最新技術が搭載',
  ],

  'ゴーレム→鎖縛': [
    '機械仕掛けの拘束具が開発される',
    'ゴーレム技術で鎖の精度が向上',
    '魔導の鎖が新たな可能性を開く',
    '機械式拘束システムが完成',
    'ゴーレム制御技術が鎖に応用',
    '逃げられない鎖、魔導技術の結晶',
  ],

  '未来鴉→呪術狩り': [
    'ミランの予言が呪術狩りを導く',
    '未来鴉の情報で魔女の拠点が判明',
    '紫鴉の囁きで狩人が動き出す',
    '時を読む鴉が呪術の未来を告げる',
    '未来鴉の情報網が狩りを効率化',
    'ミランの協力で呪術狩りが躍進',
  ],

  '未来鴉→魔女': [
    'ミランの予言が魔女にも届く',
    '未来鴉の情報は敵にも漏れる',
    '紫鴉の二重スパイ疑惑が浮上',
    '時の情報は光にも闇にも',
    '未来鴉の予言で魔女も備える',
    'ミランの鴉が魔女に警告を伝える',
  ],
};

// ----------------------------------------
// 2.5 生態系連鎖（Ecosystem Chain）
// ----------------------------------------

export const ECOSYSTEM_CHAIN_TEMPLATES = {
  '粘液獣→虹羽密林': {
    positive: [
      '粘液獣の繁殖が密林の生態系に影響',
      '粘液の養分が密林を潤す',
      'スライムの分解物が森の栄養に',
      '粘液獣と密林、共生の関係',
      '粘液の海が森に新たな生命を',
      '分解者としての粘液獣が森を支える',
    ],
  },

  '虹羽密林→フルーツ・マリオネット': {
    positive: [
      '密林の異変が果実の精霊に影響',
      '虹羽の花粉がフルーツを育てる',
      '密林の恵みが人形劇に彩りを添える',
      '森の実りが果実人形に力を',
      '密林の豊作でフルーツが輝く',
      '虹羽の森から果実の種が',
    ],
  },

  '虹羽密林→鳥民': {
    positive: [
      '密林の変化が鳥民の祭事に影響',
      '虹羽の森と天翔秘島を繋ぐ渡り鳥',
      '密林の恵みが島に届く季節',
      '森の実りが鳥民の食卓に',
      '密林の変化を鳥民は敏感に察知',
      '森と島、緑の翼で繋がれて',
    ],
  },

  'ブリザードキャット→粘液獣': {
    negative: [
      '氷の猫族が粘液獣の繁殖を抑制',
      '凍結の波動で粘液の活動が鈍る',
      'ブリザードマスターが粘液駆除を指揮',
      '氷の爪が粘液を砕く',
      '凍てつく大地に粘液は生きられず',
      '氷猫の縄張りから粘液獣は撤退',
    ],
  },

  'フェニックス→虹羽密林': {
    negative: [
      '不死鳥の炎が密林の一部を焼く',
      'フェニックスの再生炎が森に延焼',
      '聖獣の炎と密林の緑の攻防',
      '不死の炎が緑を灰に変える',
      'フェニックスの巣の周りは焼け野原',
      '再生の炎、だが森には脅威',
    ],
  },
};

// ----------------------------------------
// 2.6 属性波及連鎖（Attribute Ripple Chain）
// ----------------------------------------

/**
 * 属性波及連鎖テンプレート
 * テーマ（カテゴリ/名称）のニュースが属性全体に波及する際の文言
 */
export const ATTRIBUTE_RIPPLE_TEMPLATES = {
  '炎': [
    '炎属性全体にも注目が集まる',
    '火の国の市場も活気づく',
    '炎属性カード全般に買いが入る',
    '炎使いたちの間で話題に',
    '炎属性市場も連動して動く',
  ],
  '水': [
    '水属性全体にも波及',
    '水の国の商人も動き出す',
    '水属性カード全般が注目される',
    '海洋系カード市場も反応',
    '水属性市場に余波が及ぶ',
  ],
  '光': [
    '光属性全体にも影響',
    '光の国の市場も連動',
    '光属性カードへの関心が高まる',
    '聖なる系統全体に波及',
    '光属性市場も動意づく',
  ],
  '闇': [
    '闇属性全体にも影響が及ぶ',
    '闘の国の市場も反応',
    '闇属性カード全般に注目',
    '暗黒系カード市場も連動',
    '闇属性市場に波紋が広がる',
  ],
  '原始': [
    '原始属性全体にも波及',
    '原始の国の市場も動く',
    '自然系カード全般に関心',
    '原始属性市場も影響を受ける',
    '大地の系統に余波が及ぶ',
  ],
  '未来': [
    '未来属性全体にも注目',
    '未来の国の技術市場も反応',
    '機械系カード全般に波及',
    '未来属性市場も連動して動く',
    'テクノロジー系統に影響',
  ],
  'なし': [
    '無属性カード市場にも影響',
    '汎用カード全般に注目',
    '無属性市場も連動',
  ],
};

/**
 * 属性波及連鎖のテンプレートを取得
 * @param {string} theme - 元テーマ
 * @param {string} attribute - 波及先属性
 * @returns {string} テンプレート文言
 */
export const getAttributeRippleTemplate = (theme, attribute) => {
  const templates = ATTRIBUTE_RIPPLE_TEMPLATES[attribute];
  if (templates && templates.length > 0) {
    const template = templates[Math.floor(Math.random() * templates.length)];
    return `${theme}人気で${template}`;
  }
  return `${theme}の影響で${attribute}属性全体にも注目`;
};

// ========================================
// 3. 汎用接続文言
// ========================================

/**
 * 連鎖の導入文言
 */
export const CHAIN_INTRO_TEMPLATES = [
  // 波及系
  'この影響で',
  'これを受けて',
  'その余波で',
  'この動きに連動し',
  // 反応系
  'これに反応して',
  'この報を受け',
  'この状況を見て',
  // 結果系
  'その結果',
  'これにより',
  'この流れで',
  // 同時系
  '同時に',
  '一方で',
  'また',
];

/**
 * 変動の表現
 */
export const MODIFIER_EXPRESSIONS = {
  // 上昇（大）
  large_up: ['急騰', '高騰', '暴騰', '爆上げ', '大幅上昇'],
  // 上昇（中）
  medium_up: ['上昇', '値上がり', '好調', '堅調', '買い優勢'],
  // 上昇（小）
  small_up: ['小幅上昇', 'やや上昇', 'じわじわ上昇', '底堅い'],
  // 下落（大）
  large_down: ['暴落', '急落', '大暴落', '崩壊', '大幅下落'],
  // 下落（中）
  medium_down: ['下落', '値下がり', '軟調', '売り優勢', '低迷'],
  // 下落（小）
  small_down: ['小幅下落', 'やや下落', 'じわじわ下落', '伸び悩み'],
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * 配列からランダムに1つ選択
 */
const randomChoice = (arr) => arr[Math.floor(Math.random() * arr.length)];

/**
 * 変動率に応じた表現を選択
 * @param {number} modifier - 変動率（%）
 * @returns {string} 変動表現
 */
export const getModifierExpression = (modifier) => {
  const absModifier = Math.abs(modifier);
  const direction = modifier > 0 ? 'up' : 'down';

  let size;
  if (absModifier >= 30) size = 'large';
  else if (absModifier >= 15) size = 'medium';
  else size = 'small';

  const expressions = MODIFIER_EXPRESSIONS[`${size}_${direction}`];
  return randomChoice(expressions);
};

/**
 * 正連鎖のテンプレートを取得
 * @param {string} sourceTheme - 元テーマ
 * @param {string} targetTheme - 連鎖先テーマ
 * @returns {string} テンプレート文言
 */
export const getPositiveChainTemplate = (sourceTheme, targetTheme) => {
  const key = `${sourceTheme}→${targetTheme}`;
  const themed = POSITIVE_CHAIN_THEMED[key];
  if (themed && themed.length > 0) {
    return randomChoice(themed);
  }
  // 汎用テンプレートを使用
  const template = randomChoice(POSITIVE_CHAIN_TEMPLATES);
  return template.replace('${source}', sourceTheme).replace('${target}', targetTheme);
};

/**
 * 対抗連鎖のテンプレートを取得
 * @param {string} sourceTheme - 元テーマ
 * @param {string} targetTheme - 連鎖先テーマ
 * @returns {string} テンプレート文言
 */
export const getCounterChainTemplate = (sourceTheme, targetTheme) => {
  const key = `${sourceTheme}→${targetTheme}`;
  const themed = COUNTER_CHAIN_THEMED[key];
  if (themed && themed.length > 0) {
    return randomChoice(themed);
  }
  // 汎用テンプレートを使用
  const template = randomChoice(COUNTER_CHAIN_TEMPLATES);
  return template.replace('${source}', sourceTheme).replace('${target}', targetTheme);
};

/**
 * 負連鎖のテンプレートを取得
 * @param {string} sourceTheme - 元テーマ
 * @param {string} targetTheme - 連鎖先テーマ
 * @returns {string} テンプレート文言
 */
export const getNegativeChainTemplate = (sourceTheme, targetTheme) => {
  const key = `${sourceTheme}→${targetTheme}`;
  const themed = NEGATIVE_CHAIN_THEMED[key];
  if (themed && themed.length > 0) {
    return randomChoice(themed);
  }
  // 汎用テンプレートを使用
  const template = randomChoice(NEGATIVE_CHAIN_TEMPLATES);
  return template.replace('${source}', sourceTheme).replace('${target}', targetTheme);
};

/**
 * 宿敵連鎖のテンプレートを取得
 * @param {string} themeA - テーマA
 * @param {string} themeB - テーマB
 * @returns {string} テンプレート文言
 */
export const getRivalryChainTemplate = (themeA, themeB) => {
  const key1 = `${themeA}↔${themeB}`;
  const key2 = `${themeB}↔${themeA}`;
  const templates = RIVALRY_CHAIN_TEMPLATES[key1] || RIVALRY_CHAIN_TEMPLATES[key2];
  if (templates && templates.length > 0) {
    return randomChoice(templates);
  }
  return `${themeA}と${themeB}の衝突、両陣営に緊張`;
};

/**
 * 連鎖導入文言を取得
 * @returns {string} 導入文言
 */
export const getChainIntro = () => {
  return randomChoice(CHAIN_INTRO_TEMPLATES);
};

// ========================================
// エクスポート
// ========================================

export default {
  // 基本連鎖テンプレート
  POSITIVE_CHAIN_TEMPLATES,
  POSITIVE_CHAIN_THEMED,
  COUNTER_CHAIN_TEMPLATES,
  COUNTER_CHAIN_THEMED,
  NEGATIVE_CHAIN_TEMPLATES,
  NEGATIVE_CHAIN_THEMED,

  // 特殊連鎖テンプレート
  RIVALRY_CHAIN_TEMPLATES,
  TRIANGLE_CHAIN_TEMPLATES,
  DOMINION_CHAIN_TEMPLATES,
  TECHNOLOGY_CHAIN_TEMPLATES,
  ECOSYSTEM_CHAIN_TEMPLATES,
  ATTRIBUTE_RIPPLE_TEMPLATES,

  // 汎用文言
  CHAIN_INTRO_TEMPLATES,
  MODIFIER_EXPRESSIONS,

  // ヘルパー関数
  getModifierExpression,
  getPositiveChainTemplate,
  getCounterChainTemplate,
  getNegativeChainTemplate,
  getRivalryChainTemplate,
  getAttributeRippleTemplate,
  getChainIntro,
};
